import AdContainer from "@gik/ads/components/AdContainer";
import AdGlare from "@gik/ads/components/AdGlare";
import FallbackAd from "@gik/ads/components/FallbackAd";
import WordPressAd from "@gik/ads/components/WordPressAd";
import type ZonePool from "@gik/ads/ZonePool";
import type ArticleAdvertising from "@gik/blog/models/ArticleAdvertising";
import {
	Breakpoint,
	useBreakpoint,
} from "@gik/core/hooks/hooks/BreakpointHooks";
import { useEnvStore } from "@gik/core/store/EnvStore";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import React from "react";

const VerticalAd = "vertical";
const HorizontalAd = "horizontal";

export type AdType = typeof VerticalAd | typeof HorizontalAd;

interface AdProps {
	adType?: AdType;
	className?: string;
	override?: ArticleAdvertising;
	zone: string | ZonePool;
	mobileZone?: string | ZonePool;
}

export const adGlareGlobalKeyValueTargetKeyName = "adglare_kv_taxonomyname";

export function setKeyValuePair(keyValuePair: string) {
	if (keyValuePair && !window[adGlareGlobalKeyValueTargetKeyName]) {
		window[adGlareGlobalKeyValueTargetKeyName] = keyValuePair
			.toLowerCase()
			.replace(" ", "_")
			.replace("/", "_");
	}
}

export function clearKeyValuePair() {
	delete window[adGlareGlobalKeyValueTargetKeyName];
}

export default function AdComp({
	adType = "horizontal",
	className,
	override,
	zone,
	mobileZone,
}: AdProps) {
	const ENABLE_ADS = useEnvStore((state) => state.ENABLE_ADS);

	const isMdDown = useBreakpoint(Breakpoint.MD_DOWN);

	if (ENABLE_ADS !== "true") {
		return null;
	}

	const isAdFromWordPress = (): boolean => !!override;

	const getOverrideImage = () =>
		isMdDown
			? override.mobileMediumRectangle
			: adType === VerticalAd
				? override.desktopSkyscraper
				: override.desktopLeaderboard;

	return (
		<AdContainer adType={adType} className={className}>
			{isAdFromWordPress() ? (
				<WordPressAd link={override?.link} imageUrl={getOverrideImage()?.url} />
			) : (
				<AdGlare
					zone={isMdDown ? mobileZone : zone}
					fallbackBackEl={<FallbackAd />}
				/>
			)}
		</AdContainer>
	);
}

export const Ad = withComponentErrorBoundary(AdComp);
